export default __webpack_public_path__ + "static/media/img_introduce_in_detail_4.010dfdd9.png";